// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../.pnpm/css-loader@7.1.2_webpack@5.104.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../.pnpm/css-loader@7.1.2_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../.pnpm/css-loader@7.1.2_webpack@5.104.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Inter/Inter-VariableFont_opsz,wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/SF/SF-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/SF/SF-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/SF/SF-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/SF-Mono/SF-Mono-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/SF-Mono/SF-Mono-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/Roboto/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/fonts/Roboto/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fonts/Roboto/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/fonts/Segoe/Segoe-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/fonts/Segoe/Segoe-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/fonts/Roboto-Mono/RobotoMono-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file contains a minimal set of styles which we want to cascade */
@font-face {
  font-family: 'atomic___Inter';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format('opentype');
  font-weight: 400 700;
}

@font-face {
  font-family: 'atomic___SanFranciscoRegular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}

@font-face {
  font-family: 'atomic___SanFranciscoMedium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
}

@font-face {
  font-family: 'atomic___SanFranciscoBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
}

@font-face {
  font-family: 'atomic___SanFranciscoMono';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
  font-weight: normal;
}

@font-face {
  font-family: 'atomic___SanFranciscoMono';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
  font-weight: bold;
}

@font-face {
  font-family: 'atomic___RobotoRegular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}

@font-face {
  font-family: 'atomic___RobotoMedium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
}

@font-face {
  font-family: 'atomic___RobotoBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
}

@font-face {
  font-family: 'atomic___SegoeUIRegular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
}

@font-face {
  font-family: 'atomic___SegoeUIBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype');
}

@font-face {
  font-family: 'atomic___RobotoMono';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___})
    format('woff2-variations');
  /* params for supported weights (based on what's listed here https://fonts.google.com/specimen/Roboto+Mono/tester  */
  font-weight: 100 700;
  /* just chose a generic range */
  font-stretch: 75% 125%;
  /* Note: an italic variable font is also available for download from google fonts */
  font-style: normal;
}

html {
  box-sizing: border-box;
  height: 100%;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  height: 100%;
}
#root {
  min-height: 100%;
  display: flex;
}

/* minimal global defaults for text copy */
body,
input,
textarea,
button {
  font-family:
    atomic___Inter,
    -apple-system,
    BlinkMacSystemFont,
    Roboto,
    Segoe UI,
    Arial,
    san-serif;
  font-size: 16px;
  line-height: 1.15;
  letter-spacing: -0.03em;
}

button {
  padding: 0;
}

a,
input,
button,
textarea {
  outline: none;
}

/* :not's are attempting to exclude elements used in the SDK preview render https://stackoverflow.com/a/68211003 */
a:not(.styled-card-preview *),
button {
  cursor: pointer;
}

a:not(.styled-card-preview *) {
  color: inherit;
  text-decoration: none;
}
p {
  line-height: 1.4;
}
p > a:not(.styled-card-preview *) {
  color: #3264f0;
}
p > a:not(.styled-card-preview *):hover {
  text-decoration: underline;
}

input[type='text'],
input[type='email'],
input[type='number'],
input[type='password'],
textarea {
  width: 100%;
}

[contenteditable] {
  outline: none;
}

/* https://codepen.io/thetallweeks/pen/yybGra */
@keyframes ellipsis {
  to {
    width: 1.25em;
  }
}

@-webkit-keyframes ellipsis {
  to {
    width: 1.25em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/style.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;EACE,6BAA6B;EAC7B;sBACoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;EAC3C,+DAAgE;AAClE;;AAEA;EACE,0CAA0C;EAC1C,+DAA+D;AACjE;;AAEA;EACE,wCAAwC;EACxC,+DAA6D;AAC/D;;AAEA;EACE,wCAAwC;EACxC,+DAA0E;EAC1E,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,+DAAuE;EACvE,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,+DAAwE;AAC1E;;AAEA;EACE,oCAAoC;EACpC,+DAAuE;AACzE;;AAEA;EACE,kCAAkC;EAClC,+DAAqE;AACvE;;AAEA;EACE,sCAAsC;EACtC,+DAAsE;AACxE;;AAEA;EACE,mCAAmC;EACnC,gEAAmE;AACrE;;AAEA;EACE,kCAAkC;EAClC;8BAC4B;EAC5B,oHAAoH;EACpH,oBAAoB;EACpB,+BAA+B;EAC/B,sBAAsB;EACtB,mFAAmF;EACnF,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,0CAA0C;AAC1C;;;;EAIE;;;;;;;aAOW;EACX,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,aAAa;AACf;;AAEA,kHAAkH;AAClH;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,+CAA+C;AAC/C;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* This file contains a minimal set of styles which we want to cascade */\n@font-face {\n  font-family: 'atomic___Inter';\n  src: url('../assets/fonts/Inter/Inter-VariableFont_opsz,wght.ttf')\n    format('opentype');\n  font-weight: 400 700;\n}\n\n@font-face {\n  font-family: 'atomic___SanFranciscoRegular';\n  src: url('../assets/fonts/SF/SF-Regular.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'atomic___SanFranciscoMedium';\n  src: url('../assets/fonts/SF/SF-Medium.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'atomic___SanFranciscoBold';\n  src: url('../assets/fonts/SF/SF-Bold.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'atomic___SanFranciscoMono';\n  src: url('../assets/fonts/SF-Mono/SF-Mono-Regular.otf') format('opentype');\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'atomic___SanFranciscoMono';\n  src: url('../assets/fonts/SF-Mono/SF-Mono-Bold.otf') format('opentype');\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: 'atomic___RobotoRegular';\n  src: url('../assets/fonts/Roboto/Roboto-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'atomic___RobotoMedium';\n  src: url('../assets/fonts/Roboto/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'atomic___RobotoBold';\n  src: url('../assets/fonts/Roboto/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'atomic___SegoeUIRegular';\n  src: url('../assets/fonts/Segoe/Segoe-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'atomic___SegoeUIBold';\n  src: url('../assets/fonts/Segoe/Segoe-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'atomic___RobotoMono';\n  src: url('../assets/fonts/Roboto-Mono/RobotoMono-VariableFont_wght.ttf')\n    format('woff2-variations');\n  /* params for supported weights (based on what's listed here https://fonts.google.com/specimen/Roboto+Mono/tester  */\n  font-weight: 100 700;\n  /* just chose a generic range */\n  font-stretch: 75% 125%;\n  /* Note: an italic variable font is also available for download from google fonts */\n  font-style: normal;\n}\n\nhtml {\n  box-sizing: border-box;\n  height: 100%;\n}\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n\nbody {\n  height: 100%;\n}\n#root {\n  min-height: 100%;\n  display: flex;\n}\n\n/* minimal global defaults for text copy */\nbody,\ninput,\ntextarea,\nbutton {\n  font-family:\n    atomic___Inter,\n    -apple-system,\n    BlinkMacSystemFont,\n    Roboto,\n    Segoe UI,\n    Arial,\n    san-serif;\n  font-size: 16px;\n  line-height: 1.15;\n  letter-spacing: -0.03em;\n}\n\nbutton {\n  padding: 0;\n}\n\na,\ninput,\nbutton,\ntextarea {\n  outline: none;\n}\n\n/* :not's are attempting to exclude elements used in the SDK preview render https://stackoverflow.com/a/68211003 */\na:not(.styled-card-preview *),\nbutton {\n  cursor: pointer;\n}\n\na:not(.styled-card-preview *) {\n  color: inherit;\n  text-decoration: none;\n}\np {\n  line-height: 1.4;\n}\np > a:not(.styled-card-preview *) {\n  color: #3264f0;\n}\np > a:not(.styled-card-preview *):hover {\n  text-decoration: underline;\n}\n\ninput[type='text'],\ninput[type='email'],\ninput[type='number'],\ninput[type='password'],\ntextarea {\n  width: 100%;\n}\n\n[contenteditable] {\n  outline: none;\n}\n\n/* https://codepen.io/thetallweeks/pen/yybGra */\n@keyframes ellipsis {\n  to {\n    width: 1.25em;\n  }\n}\n\n@-webkit-keyframes ellipsis {\n  to {\n    width: 1.25em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
